<template>
  <div class="articles">
    <div class="container">
      <div class="card z-depth-3">
        <div class="card-header mb-4 blue-gradient text-light">
          <h1 class="title-header text-center" id="title-header">
            {{ article.titre }}
          </h1>
        </div>
        <div class="card-body" style="min-height: 1050px;">
          <div class="aarticles text-center">
            <div id="view" class="view overlay zoom z-depth-2 mb-3">
              <img :src="article.image" class="img-fluid rounded w-100" />
              <div
                class="mask flex-center waves-effect waves-light rgba-black-strong "
              >
                <p class="white-text msk">
                  {{ article.titre }}
                </p>
              </div>
            </div>
            <p class="articleContent mt-4" style="overflow-x:auto;">
              <!-- article content -->
              <!-- <div class="text-center spinner text-primary">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                    </div> -->
              {{ article.content }}
            </p>
          </div>
        </div>
      </div>
      <!-- end firstcard -->

      <!--Section: Author Box-->
      <section class="my-5  wow fadeIn">
        <div class="card pb-3">
          <!-- Card header -->
          <div
            class="card-header blue-gradient text-light border-0 font-weight-bold d-flex justify-content-between"
          >
            <p class="mr-4 mb-0 text-light">A propos de l'auteur</p>
          </div>

          <div class="media mt-4 px-1">
            <img
              class="card-img-100 rounded-circle d-flex z-depth-1 mx-3"
              src="@/assets/image/user.png"
              alt="image de profile"
              id="authProf"
            />
            <div class="media-body">
              <!-- <h5 class="font-weight-bold mt-0"> -->
              <h4 class="text-primary font-weight-bold" id="authName" href="">
                {{ user }}
              </h4>
              <!-- </h5> -->
              <ul class="list-unstyled list-inline mb-2 pt-1">
                <li class="list-inline-item">
                  <a class="grey-text mr-1"
                    ><i class="fab fa-lg fa-facebook"> </i
                  ></a>
                </li>
                <li class="list-inline-item">
                  <a class="grey-text mr-1"
                    ><i class="fab fa-lg fa-twitter"> </i
                  ></a>
                </li>
                <li class="list-inline-item">
                  <a class="grey-text mr-1"
                    ><i class="fab fa-lg fa-linkedin"> </i
                  ></a>
                </li>
                <li class="list-inline-item">
                  <a class="grey-text mr-1"
                    ><i class="fab fa-lg fa-instagram"> </i
                  ></a>
                </li>
              </ul>
              <p id="authDesc"></p>
            </div>
          </div>
        </div>
      </section>

      <!-- Section: Blog v.2 -->
      <section id="recentPosts-sec" class="text-center my-5">
        <!-- Section heading -->
        <h2
          class="h1-responsive font-weight-bold my-5 blue-gradient p-4 text-light"
        >
          Les derniers articles
        </h2>

        <!-- Grid row -->
        <div class="row" id="recentPosts">
          <!-- pink-text deep-orange-text blue-text-->
        </div>
        <!-- Grid row -->
      </section>
      <!-- Section: Blog v.2 -->

      <!--Section: Comments-->
      <section class="my-5" id="com-sec">
        <!-- Card header -->
        <div class="card-header border-0 font-weight-bold" id="nbrComment">
          Chargement ...
        </div>
        <div class="comments" style="max-height:600px;overflow-y:auto;">
          <!-- Quick Reply -->
          <div class="md-form mt-4 d-none" id="commentArea1">
            <label id="labelCom" for="quickReplyFormComment"
              >le commentaire</label
            >
            <textarea
              class="form-control md-textarea"
              id="quickReplyFormComment"
              rows="3"
            ></textarea>

            <div class="text-center my-4">
              <button
                class="btn btn-default btn-sm btn-rounded disabled"
                id="post-comment"
              >
                Poster
              </button>
            </div>
          </div>
        </div>

        <div class="justify-content-center d-none" id="CommentNotLogedIn">
          <a
            name=""
            id=""
            class="btn btn-primary"
            href="../signin/signin.php"
            role="button"
            >Connexion ou inscription</a
          >
        </div>
        <!--Pagination -->
        <nav
          class=" justify-content-center mt-5 d-none disabled"
          id="commentArea2"
        >
          <ul class="pagination pagination-circle pg-teal mb-0">
            <!--First-->
            <li class="page-item disabled">
              <a class="page-link">First</a>
            </li>

            <!--Arrow left-->
            <li class="page-item disabled">
              <a class="page-link" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>

            <!--Numbers-->
            <li class="page-item active">
              <a class="page-link">1</a>
            </li>
            <li class="page-item">
              <a class="page-link">2</a>
            </li>
            <li class="page-item">
              <a class="page-link">3</a>
            </li>
            <li class="page-item">
              <a class="page-link">4</a>
            </li>
            <li class="page-item">
              <a class="page-link">5</a>
            </li>

            <!--Arrow right-->
            <li class="page-item">
              <a class="page-link" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>

            <!--Last-->
            <li class="page-item">
              <a class="page-link">Last</a>
            </li>
          </ul>
        </nav>
        <!--Pagination -->
      </section>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebase";

export default {
  data() {
    return {
      id: this.$route.params.id,
      user: null,
      article: null
    };
  },
  firebase() {
    return {
      article: db.ref().child("articles/" + this.id)
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    console.log(this.$route.params.id);
  },
  watch: {
    article: function() {
      console.log("upeaded");
      var self = this;
      db.ref()
        .child("users")
        .on("child_added", e => {
          if (self.article.authUid == e.val().UID) {
            self.user = e.val();
            console.log(e.val());
          } else {
            console.log(self.article.authUid, e.val().UID);
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.articleContent img {
  max-width: 550px;
  border: 2px solid #000098;
  border-radius: 5px;
  padding: 5px;
}

.media .avatar {
  width: 44px;
}

.at-expanding-share-button-toggle-bg span {
  background-color: #000098 !important;
}

.position-none {
  position: unset;
}

.dropdown-menu span {
  cursor: pointer;
}

.md-form textarea.md-textarea:focus:not([readonly]) {
  box-shadow: 0 1px 0 0 #2bbbad;
  border-bottom: 1px solid #2bbbad;
}

@media (max-width: 1199.98px) {
  .dropdown-menu {
    left: 0 !important;
    right: 0 !important;
  }
}

@media (min-width: 576px) {
}

/* Medium devices (tablets, 768px and up)*/
@media (min-width: 768px) {
  .position-md-absolute {
    position: absolute !important;
  }
}
</style>